import { render } from "./Items.vue?vue&type=template&id=64516f9a&scoped=true"
import script from "./Items.vue?vue&type=script&lang=js"
export * from "./Items.vue?vue&type=script&lang=js"

import "./Items.vue?vue&type=style&index=0&id=64516f9a&scoped=true&lang=css"
import "./Items.vue?vue&type=style&index=1&id=64516f9a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64516f9a"]])

export default __exports__